import {useState} from 'react'
import RiskAssessmentForm from "./RiskAssessmentForm";
import RiskAssessmentList from './RiskAssessmentList';

const ProRiskAssessment = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);

return (
  <>
    {fromIsShown ? (
        <RiskAssessmentForm addForm={setFromIsShown} update={upData} />
      ) : (
        <RiskAssessmentList addForm={setFromIsShown} update={setUpData} />
      )}

  </>
  )
}

export default ProRiskAssessment